const mutations = {
  mutationGadgets(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.gadgets[payload.tab] = payload.responseData;
    } else {
      state.gadgets = payload;
    }
  },

  mutationGadgetsMeta(state, payload) {
    state.gadgetsMeta = payload;
  },

  // this is for lazy loading
  mutationGadgetsAll(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      payload.responseData.forEach((item) => {
        if (typeof state.gadgetsAll[payload.tab] === "undefined") {
          state.gadgetsAll[payload.tab] = [];
        }

        state.gadgetsAll[payload.tab].push(item);
      });
    } else if (!payload.length) {
      state.gadgetsAll = [];
    } else {
      payload.forEach((item) => {
        state.gadgetsAll.push(item);
      });
    }
  },

  mutationPolicies(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.policies[payload.tab] = payload.response.data;

      // set meta
      state.policiesMeta = payload.response.meta;
    } else {
      state.policies = payload.data;
      state.policiesMeta = payload.meta;
    }
  },

  // this is for lazy loading
  mutationPoliciesAll(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      payload.response.data.forEach((item) => {
        if (typeof state.policiesAll[payload.tab] === "undefined") {
          state.policiesAll[payload.tab] = [];
        }

        state.policiesAll[payload.tab].push(item);
      });
    } else if (!payload.length) {
      state.policiesAll = [];
    } else {
      payload.forEach((item) => {
        state.policiesAll.push(item);
      });
    }
  },

  mutationPolicy(state, payload) {
    state.policy = payload;
  },

  mutationClaims(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.claims[payload.tab] = payload.response.data;

      // set meta
      state.claimsMeta = payload.response.meta;
    } else {
      state.claims = payload.data;
      state.claimsMeta = payload.meta;
    }
  },

  // this is for lazy loading
  mutationClaimsAll(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      payload.response.data.forEach((item) => {
        if (typeof state.claimsAll[payload.tab] === "undefined") {
          state.claimsAll[payload.tab] = [];
        }

        state.claimsAll[payload.tab].push(item);
      });
    } else if (!payload.length) {
      state.claimsAll = [];
    } else {
      payload.forEach((item) => {
        state.claimsAll.push(item);
      });
    }
  },

  mutationClaim(state, payload) {
    state.claim = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProducts(state, payload) {
    state.products = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },

  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },

  mutationCreatePolicy(state, payload) {
    state.createPolicy = payload;
  },

  mutationGadgetCategory(state, payload) {
    state.gadgetCategory = payload;
  },

  mutationProductService(state, payload) {
    state.productService = payload;
  },

  mutationProductServiceBuybackProgram(state, payload) {
    state.productServiceBuybackProgram = payload;
  },

  mutationListBrand(state, payload) {
    state.listBrand = payload;
  },

  mutationListType(state, payload) {
    state.listType = payload;
  },

  mutationCreateClaim(state, payload) {
    state.createClaim = payload;
  },

  mutationIsValidCreateClaim(state, payload) {
    state.isValidCreateClaim = payload;
  },

  mutationQuestionCostEstimation(state, payload) {
    state.questionCostEstimation = payload;
  },

  mutationFilesCostEstimation(state, payload) {
    state.filesCostEstimation = payload;
  },

  mutationExtractImei(state, payload) {
    state.extractImei = payload;
  },

  mutationPaymentMethod(state, payload) {
    state.paymentMethod = payload;
  },

  mutationAgentList(state, payload) {
    state.agentList = payload;
  },

  mutationEditPolicyHistory(state, payload) {
    state.editPolicyHistory = payload;
  },

  mutationListClaimsHistoriesClaim(state, payload) {
    state.claimsHistoriesClaim = payload;
  },

  mutationListServiceCenter(state, payload) {
    state.serviceCenters = payload;
  },
};

export default mutations;
